<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading">
            {{ $t("loadingTxt") }}...
        </div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->

            <div class="page-wrapper">
                <!--begin::content-->
                <div class="page-content">
                    <div class="row">
                        <div>
                            <h4 class="mb-12 mb-md-0"></h4>
                        </div>

                        <div class="col-lg-12 col-xl-12 stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="float-start">{{ $t("rate_detail_storage") }}</h4>
                                    <button v-if="
                                        permision_role.method_create &&
                                        formsHeader.status == 'DISABLED'
                                    " class="btn btn-primary float-end btn-xs" style="margin-right: 5px" @click.prevent="createData()">
                                        <i class="link-icon mdi mdi-plus"></i>
                                        {{ $t("createNew") }}
                                    </button>

                                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="downloadData()">
                                        <i class="link-icon mdi mdi-download"></i>
                                        {{ $t("downloadData") }} .xlsx
                                    </button>

                                    <button v-if="permision_role.method_read" class="btn btn-warning float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="backForm()">
                                        <i class="link-icon mdi mdi-arrow-left"></i>
                                        {{ $t("backMess") }}
                                    </button>
                                </div>

                                <div class="card-body">
                                    <div class="row justify-content-md-center px-3">
                                        <div class="row mb-3">
                                            <div class="col-md-12">
                                                <label class="form-label">{{
                                                    $t("rateBaseDesc_txt")
                                                    }}</label>
                                                <input type="text" class="form-control" id="rateBaseDesc"
                                                    :placeholder="$t('rateBaseDesc_txt')"
                                                    v-model="formsStorage.rateBaseDesc" disabled />
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <label class="form-label">{{
                                                    $t("chargeCategory_txt")
                                                    }}</label>
                                                <input type="text" class="form-control" id="chargeCategory"
                                                    :placeholder="$t('chargeCategory_txt')"
                                                    v-model="formsStorage.chargeCategory" disabled />
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{
                                                    $t("chargeType_txt")
                                                    }}</label>
                                                <input type="text" class="form-control" id="chargeType"
                                                    :placeholder="$t('chargeType_txt')"
                                                    v-model="formsStorage.chargeType" disabled />
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{
                                                    $t("SAPMaterialCode")
                                                    }}</label>
                                                <input type="text" class="form-control" id="SAPMaterialCode"
                                                    :placeholder="$t('SAPMaterialCode')"
                                                    v-model="formsStorage.SAPMaterialCode" disabled />
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <label class="form-label">{{
                                                    $t("SAPDivision")
                                                    }}</label>
                                                <input type="text" class="form-control" id="SAPDivision"
                                                    :placeholder="$t('SAPDivision')" v-model="formsStorage.SAPDivision"
                                                    disabled />
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{ $t("uom") }}</label>
                                                <input type="text" class="form-control" id="uom"
                                                    :placeholder="$t('uom')" v-model="formsStorage.uom" disabled />
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{
                                                    $t("opportunity_id")
                                                    }}</label>
                                                <input type="text" class="form-control" id="opportunity_id"
                                                    :placeholder="$t('opportunity_id')"
                                                    v-model="formsStorage.opportunity_id" disabled />
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <label class="form-label">{{ $t("minQty") }}</label>
                                                <input type="text" class="form-control" id="minQty"
                                                    :placeholder="$t('minQty')" v-model="formsStorage.minQty"
                                                    disabled />
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{ $t("minAmount") }}</label>
                                                <money class="form-control" v-model="formsStorage.minAmount"
                                                    v-bind="money" disabled></money>
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{
                                                    $t("summaryFlag")
                                                    }}</label>
                                                <input type="text" class="form-control" id="summaryFlag"
                                                    :placeholder="$t('summaryFlag')" v-model="formsStorage.summaryFlag"
                                                    disabled />
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <label class="form-label">{{ $t("rate_txt") }}</label>
                                                <money class="form-control" v-model="formsStorage.rate" v-bind="money"
                                                    disabled></money>
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{ $t("proRate") }}</label>
                                                <input type="text" class="form-control" id="proRate"
                                                    :placeholder="$t('proRate')" v-model="formsStorage.proRate"
                                                    disabled />
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">{{ $t("remark") }}</label>
                                                <input type="text" class="form-control" id="remark"
                                                    :placeholder="$t('remark')" v-model="formsStorage.remark"
                                                    disabled />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-body">
                                    <div class="row justify-content-md-center px-3">
                                        <vue-good-table title="list-billing-cml-rate-detail-sub-storage" :rows="rows"
                                            :columns="columns" :sort-options="{
                                                enabled: true,
                                            }" :search-options="{
                        enabled: true,
                        trigger: 'enter',
                    }">
                                            <template slot="table-row" slot-scope="props">
                                                <span v-if="props.column.field == 'actions'">
                                                    <a href="#" v-if="permision_role.method_read" title="Detail"
                                                        @click.prevent="detailData(props.index, props.row)">
                                                        <i class="mdi mdi-eye" style="font-size: 16px"></i>
                                                    </a>
                                                    <a href="#" v-if="
                                                        permision_role.method_update &&
                                                        formsHeader.status == 'DISABLED'
                                                    " title="Edit" @click.prevent="editData(props.index, props.row)">
                                                        <i class="mdi mdi-square-edit-outline"
                                                            style="font-size: 16px"></i>
                                                    </a>

                                                    <a href="#" v-if="
                                                        permision_role.method_delete &&
                                                        formsHeader.status == 'DISABLED'
                                                    " title="Delete" @click.prevent="deleteData(props.index, props.row)">
                                                        <i class="mdi mdi-trash-can-outline"
                                                            style="font-size: 16px"></i>
                                                    </a>
                                                </span>
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>
                                        </vue-good-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::content-->

                <!--begin::modal-->

                <modal name="createBillingCmlRateDetailSubStorage" :draggable="false" :scrollable="true"
                    :height="'auto'">
                    <div class="modal fade show" tabindex="-1" style="display: block" aria-modal="true" role="dialog">
                        <div class="modal-dialog modal-dialog-centered modal-xl">
                            <div class="modal-content">
                                <form class="forms-sample" @submit.prevent="submitData" method="POST">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">
                                            {{ this.$t("create_rate_detail_substorage") }}
                                        </h5>
                                        <button type="button" class="btn-close" aria-label="btn-close"
                                            @click.prevent="removeModals()"></button>
                                    </div>

                                    <div class="modal-body">
                                        <div class="row justify-content-md-center px-3">
                                            <div class="mb-3">
                                                <label for="idRateBase" class="form-label">{{ this.$t("rateBase_txt")
                                                    }}:</label>

                                                <v-select :options="fetchRate" v-model="bm_rate_base"
                                                    label="rateBaseDesc" return-object @search="asyncSearchRate"
                                                    @input="rateChange">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.idRateBase }} | {{ option.uom }} |
                                                        {{ option.rateBaseDesc }}
                                                    </template>
                                                </v-select>

                                                <div v-if="errors.idRateBase">
                                                    <div v-for="error in errors.idRateBase" :key="error"
                                                        class="alert alert-primary" role="alert">
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <label for="queryFormula" class="form-label">{{ this.$t("query")
                                                    }}:</label>
                                                <textarea class="form-control" id="query" :placeholder="$t('query')"
                                                    v-model="forms.queryFormula" rows="10" max-rows="20"
                                                    disabled></textarea>
                                                <div v-if="errors.queryFormula">
                                                    <div v-for="error in errors.queryFormula" :key="error"
                                                        class="alert alert-primary" role="alert">
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <label for="locationCategory" class="form-label">{{
                                                    this.$t("locationCategory")
                                                    }}:</label>
                                                <v-select :options="fetchlocationCategory" v-model="locationCategory"
                                                    label="keyLocation" return-object
                                                    @search="asyncSearchlocationCategory"
                                                    @input="rateChangelocationCategory">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.warehouseId }} |
                                                        {{ option.locationCategory }} | {{ option.zona }}
                                                    </template>
                                                </v-select>
                                                <div v-if="errors.locationCategory">
                                                    <div v-for="error in errors.locationCategory" :key="error"
                                                        class="alert alert-primary" role="alert">
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">
                                            {{ this.$t("close_txt") }}
                                        </button>
                                        <button type="submit" class="btn btn-primary">
                                            {{ this.$t("save_change_txt") }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="detailBillingCmlRateDetailSubStorage" :draggable="false" :scrollable="true"
                    :height="'auto'">
                    <div class="modal fade show" tabindex="-1" style="display: block" aria-modal="true" role="dialog">
                        <div class="modal-dialog modal-dialog-centered modal-xl">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">
                                        {{ this.$t("detail_rate_detail_substorage") }}
                                    </h5>
                                    <button type="button" class="btn-close" aria-label="btn-close"
                                        @click.prevent="removeModals()"></button>
                                </div>

                                <div class="modal-body">
                                    <div class="row justify-content-md-center px-3">
                                        <div class="mb-3">
                                            <label for="rateBaseName" class="form-label">{{ this.$t("rateBaseName_txt")
                                                }}:</label>
                                            <input type="text" class="form-control" id="rateBaseName"
                                                :placeholder="$t('rateBaseName_txt')"
                                                v-model="bm_rate_base.rateBaseName" disabled />
                                            <div v-if="errors.rateBaseName">
                                                <div v-for="error in errors.rateBaseName" :key="error"
                                                    class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <label for="rateBaseDesc" class="form-label">{{ this.$t("rateBaseDesc_txt")
                                                }}:</label>
                                            <input type="text" class="form-control" id="rateBaseDesc"
                                                :placeholder="$t('rateBaseDesc_txt')"
                                                v-model="bm_rate_base.rateBaseDesc" disabled />
                                            <div v-if="errors.rateBaseDesc">
                                                <div v-for="error in errors.rateBaseDesc" :key="error"
                                                    class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <label for="uom" class="form-label">{{ this.$t("uom") }}:</label>
                                            <input type="text" class="form-control" id="uom" :placeholder="$t('uom')"
                                                v-model="bm_rate_base.uom" disabled />
                                            <div v-if="errors.uom">
                                                <div v-for="error in errors.uom" :key="error"
                                                    class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <label for="queryFormula" class="form-label">{{ this.$t("query") }}:</label>
                                            <textarea class="form-control" id="query" :placeholder="$t('query')"
                                                v-model="forms.queryFormula" rows="10" max-rows="20"
                                                disabled></textarea>
                                            <div v-if="errors.queryFormula">
                                                <div v-for="error in errors.queryFormula" :key="error"
                                                    class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <label for="locationCategory" class="form-label">{{
                                                this.$t("locationCategory") }}:</label>
                                            <input type="text" class="form-control" id="locationCategory"
                                                :placeholder="$t('locationCategory')" v-model="forms.locationCategory"
                                                disabled />
                                            <div v-if="errors.locationCategory">
                                                <div v-for="error in errors.locationCategory" :key="error"
                                                    class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer justify-content-between">
                                    <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">
                                        {{ this.$t("close_txt") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="editBillingCmlRateDetailSubStorage" :draggable="false" :scrollable="true" :height="'auto'">
                    <div class="modal fade show" tabindex="-1" style="display: block" aria-modal="true" role="dialog">
                        <div class="modal-dialog modal-dialog-centered modal-xl">
                            <div class="modal-content">
                                <form class="forms-sample" @submit.prevent="submitEditData" method="POST">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">
                                            {{ this.$t("update_rate_detail_substorage") }}
                                        </h5>
                                        <button type="button" class="btn-close" aria-label="btn-close"
                                            @click.prevent="removeModals()"></button>
                                    </div>

                                    <div class="modal-body">
                                        <div class="row justify-content-md-center px-3">
                                            <div class="mb-3">
                                                <label for="idRateBase" class="form-label">{{ this.$t("rateBase_txt")
                                                    }}:</label>

                                                <v-select :options="fetchRate" v-model="bm_rate_base"
                                                    label="rateBaseDesc" return-object @search="asyncSearchRate"
                                                    @input="rateChange">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.idRateBase }} | {{ option.uom }} |
                                                        {{ option.rateBaseDesc }}
                                                    </template>
                                                </v-select>

                                                <div v-if="errors.idRateBase">
                                                    <div v-for="error in errors.idRateBase" :key="error"
                                                        class="alert alert-primary" role="alert">
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <label for="queryFormula" class="form-label">{{ this.$t("query")
                                                    }}:</label>
                                                <textarea class="form-control" id="query" :placeholder="$t('query')"
                                                    v-model="forms.queryFormula" rows="10" max-rows="20"
                                                    disabled></textarea>
                                                <div v-if="errors.queryFormula">
                                                    <div v-for="error in errors.queryFormula" :key="error"
                                                        class="alert alert-primary" role="alert">
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <label for="locationCategory" class="form-label">{{
                                                    this.$t("locationCategory")
                                                    }}:</label>

                                                <v-select :options="fetchlocationCategory" v-model="locationCategory"
                                                    label="keyLocation" return-object
                                                    @search="asyncSearchlocationCategory"
                                                    @input="rateChangelocationCategory">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.warehouseId }} |
                                                        {{ option.locationCategory }} | {{ option.zona }}
                                                    </template>
                                                </v-select>

                                                <!-- <input type="text" class="form-control" id="locationCategory" :placeholder="$t('locationCategory')" v-model="forms.locationCategory" required/> -->

                                                <div v-if="errors.locationCategory">
                                                    <div v-for="error in errors.locationCategory" :key="error"
                                                        class="alert alert-primary" role="alert">
                                                        <i data-feather="alert-circle"></i>
                                                        {{ error }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">
                                            {{ this.$t("close_txt") }}
                                        </button>
                                        <button type="submit" class="btn btn-primary">
                                            {{ this.$t("save_change_txt") }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </modal>

                <!--end::modal-->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
    name: "CmlRateDetailSubStorageIndex",
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
    },
    computed: {
        solicitorsFeesDisplay: {
            get: function () {
                return this.forms.rate.toFixed(5);
            },
            set: function (newValue) {
                this.forms.rate = newValue;
            },
        },
    },
    data() {
        return {
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "IDR ",
                suffix: "",
                precision: 2,
                masked: false,
            },
            maxToasts: 100,
            fetchRate: [],
            fetchlocationCategory: [],
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            idSubdetailRates: [],
            detailDivisi: [],
            bm_rate_detail_storage: null,
            bm_rate_base: {
                idRateBase: "",
                rateBaseName: "",
                chargeCategory: "",
                chargeType: "",
                SAPMaterialCode: "",
                SAPDivision: "",
                queryFormula: "",
                uom: "",
                addwho: "",
                rateBaseDesc: "",
                editwho: "",
                adddate: "",
                editdate: "",
            },
            locationCategory: null,
            forms: {
                idSubdetailRate: "",
                idRateHeader: "",
                idRateDetailStorage: "",
                adddate: "",
                addwho: "",
                editdate: "",
                editwho: "",
                locationCategory: "",
                queryFormula: "",
            },
            formsStorage: {
                opportunity_id: "",
                uom: "",
                idRateDetailStorage: "",
                idRateHeader: "",
                chargeCategory: "",
                adddate: "",
                addwho: "",
                editdate: "",
                editwho: "",
                SAPMaterialCode: "",
                chargeType: "",
                rate: 0,
                SAPDivision: "",
                remark: "",
                minQty: 0,
                minAmount: 0,
                rateBaseDesc: "",
                summaryFlag: "N",
                proRate: 0,
            },
            formsHeader: {
                idRateHeader: "",
                organizationId: "",
                customerId: "",
                customerSAPCode: "",
                tariffId: "",
                warehouseId: "",
                rateName: "",
                effectiveDate: "",
                rateDesc: "",
                firstBilingDate: "",
                effectiveFromDate: "",
                effectiveToDate: "",
                status: "",
                addwho: "",
                editwho: "",
                adddate: "",
                editdate: "",
            },
            totalRecords: 0,
            effectiveToDate: "",
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            columns: [
                {
                    label: this.$t("rateBaseName_txt"),
                    field: "bm_rate_base.rateBaseName",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("rateBaseName_txt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t("rateBaseDesc_txt"),
                    field: "bm_rate_base.rateBaseDesc",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("rateBaseDesc_txt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t("uom"),
                    field: "bm_rate_base.uom",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("uom"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t("locationCategory"),
                    field: "locationCategory",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("locationCategory"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                        enabled: false,
                    },
                },
            ],
            rows: [],
            rowsSelection: [],
            debounceTimer: null,

        };
    },
    watch: {},
    methods: {
        detailData(index, row) {
            this.forms.idSubdetailRate = row.idSubdetailRate;
            this.forms.idRateBase = row.idRateBase;
            this.forms.idRateHeader = row.idRateHeader;
            this.forms.idRateDetailStorage = row.idRateDetailStorage;
            this.forms.queryFormula = row.queryFormula;
            this.forms.locationCategory = row.locationCategory;
            this.forms.adddate = row.adddate;
            this.forms.editdate = row.editdate;
            this.errors = [];
            this.bm_rate_detail_storage = null;
            this.bm_rate_base = row.bm_rate_base;
            this.$modal.show("detailBillingCmlRateDetailSubStorage");
        },

        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        submitEditData() {
            this.isLoading = true;
            this.forms.idRateDetailStorage = this.formsStorage.idRateDetailStorage;
            this.forms.idRateHeader = this.formsStorage.idRateHeader;

            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-sub-detail-storage-update/" +
                this.forms.idSubdetailRate;
            this.$http
                .patch(baseURI, this.forms, { timeout: 60000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        //this.resetForm();
                        this.isLoading = false;
                        this.errors = [];
                        this.removeModals();
                        this.loadItems();
                        this.success("Successfully");
                    } else {
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    this.isLoading = false;

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push("/server-error");
                            } else {
                                this.$router.push("/page-not-found");
                            }
                        }
                    }

                    //this.resetForm();
                });
        },

        submitData() {
            this.isLoading = true;
            this.forms.idRateDetailStorage = this.formsStorage.idRateDetailStorage;
            this.forms.idRateHeader = this.formsStorage.idRateHeader;

            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-sub-detail-storage-create";
            this.$http
                .post(baseURI, this.forms, { timeout: 60000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                        //this.resetForm();
                        this.isLoading = false;
                        this.errors = [];
                        this.removeModals();
                        this.loadItems();
                        this.success("Successfully");
                    } else {
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    this.isLoading = false;

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push("/server-error");
                            } else {
                                this.$router.push("/page-not-found");
                            }
                        }
                    }
                });
        },

        rateChangelocationCategory(ev) {
            this.forms.locationCategory = ev.keyLocation;
        },

        getLocationCategory() {
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/location-category/get-data";

            return this.$http
                .get(
                    baseURI + `?limit=1000&warehouseId=${this.formsHeader.warehouseId}`,
                    { timeout: 60000 }
                )
                .then((response) => {
                    this.fetchlocationCategory = response.data.datas.data;
                })
                .catch((error) => {
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }
                });
        },

        asyncSearchlocationCategory(ev) {
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/location-category/get-data";
            return this.$http
                .get(
                    baseURI +
                    `?limit=1000&warehouseId=${this.formsHeader.warehouseId}&locationCategory=${ev}`,
                    { timeout: 60000 }
                )
                .then((response) => {
                    this.fetchlocationCategory = response.data.datas.data;
                });
        },

        rateChange(ev) {
            this.forms.idRateBase = ev.idRateBase;
            this.forms.queryFormula = ev.queryFormula;
        },

        getRateBase() {
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/ratebase/get-data";

            return this.$http
                .get(baseURI + `?limit=1000&status=ACTIVE`, { timeout: 60000 })
                .then((response) => {
                    this.fetchRate = response.data.datas.data;
                })
                .catch((error) => {
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }
                });
        },

        asyncSearchRate(ev,loading) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                loading(true);

                const baseURI =
                    this.$settings.endPointBilling +
                    "dashboard/cml-billing/ratebase/get-data";
                return this.$http
                    .get(baseURI + `?rateBaseDesc=${ev}&limit=1000&status=ACTIVE`, { timeout: 30000 })
                    .then((response) => {
                        this.fetchRate = response.data.datas.data;
                    }).finally(()=>{
                        loading(false);
                    });
            }, 3000); // 2 seconds
        },

        backForm() {
            var params = this.$onRandom(this.formsStorage.idRateHeader);
            window.location.href = "/billing-cml/rates/detail-storage/" + params;
        },

        removeModals() {
            this.$modal.hide("createBillingCmlRateDetailSubStorage");
            this.$modal.hide("detailBillingCmlRateDetailSubStorage");
            this.$modal.hide("editBillingCmlRateDetailSubStorage");
            this.forms.idSubdetailRate = "";
            this.forms.idRateHeader = "";
            this.forms.idRateBase = "";
            this.forms.idRateDetailStorage = "";
            this.forms.queryFormula = "";
            this.locationCategory = "";
            this.forms.adddate = "";
            this.forms.editdate = "";
            this.errors = [];
            this.bm_rate_detail_storage = null;
            this.bm_rate_base = {
                idRateBase: "",
                rateBaseName: "",
                chargeCategory: "",
                chargeType: "",
                SAPMaterialCode: "",
                SAPDivision: "",
                queryFormula: "",
                uom: "",
                addwho: "",
                rateBaseDesc: "",
                editwho: "",
                adddate: "",
                editdate: "",
            };
        },

        selectionChanged(ev) {
            this.rowsSelection = [];
            this.idSubdetailRates = [];
            this.rowsSelection = ev.selectedRows;

            this.rowsSelection.forEach((item) => {
                this.idSubdetailRates.push(item.idSubdetailRate);
            });
        },

        downloadData() {
            var params = this.$onBehind(this.$route.params.id);
            var idRateDetailStorage = params[0];
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-sub-detail-storage/" +
                idRateDetailStorage;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";

            return this.$http
                .get(baseURI + `?download=download`, {
                    responseType: "blob",
                })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
        },

        createData() {
            this.$modal.show("createBillingCmlRateDetailSubStorage");
        },

        editData(index, row) {
            // this.asyncSearchlocationCategoryEdit (row.locationCategory)
            this.forms.idSubdetailRate = row.idSubdetailRate;
            this.forms.idRateHeader = row.idRateHeader;
            this.forms.idRateBase = row.idRateBase;
            this.forms.idRateDetailStorage = row.idRateDetailStorage;
            this.forms.queryFormula = row.queryFormula;
            this.forms.locationCategory = row.locationCategory;
            this.forms.adddate = row.adddate;
            this.forms.editdate = row.editdate;
            this.fetchRate = [];
            this.fetchlocationCategory = [];
            this.bm_rate_base = row.bm_rate_base;
            this.locationCategory = { keyLocation: row.locationCategory };
            this.$modal.show("editBillingCmlRateDetailSubStorage");
            this.loadItems();
        },

        asyncSearchlocationCategoryEdit(ev) {
            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/location-category/get-data";
            return this.$http
                .get(
                    baseURI +
                    `?limit=100&page=1&warehouseId=${this.formsHeader.warehouseId}&keyLocation=${ev}`,
                    { timeout: 60000 }
                )
                .then((response) => {
                    this.locationCategory = response.data.datas.data[0];
                });
        },

        deleteData(index, row, status) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    var formData = {
                        status: status,
                    };
                    const baseURI =
                        this.$settings.endPointBilling +
                        "dashboard/cml-billing/rate/bm-rate-sub-detail-storage-delete/" +
                        row.idSubdetailRate;
                    this.$http
                        .delete(baseURI, formData, { timeout: 60000 })
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.loading();

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                            } else {
                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                        this.$router.push("/server-error");
                                    } else {
                                        this.$router.push("/page-not-found");
                                    }
                                }
                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },

        // load items is what brings back the rows from server
        loadItems() {
            var params = this.$onBehind(this.$route.params.id);
            var idRateDetailStorage = params[0];

            const baseURI =
                this.$settings.endPointBilling +
                "dashboard/cml-billing/rate/bm-rate-detail-detail-storage/" +
                idRateDetailStorage;
            this.isLoading = true;

            return this.$http
                .get(baseURI, { timeout: 60000 })
                .then((response) => {
                    this.formsStorage = response.data.datas;
                    this.formsStorage.opportunity_id =
                        response.data.datas.bm_rate_header.opportunity_id;
                    this.formsHeader = response.data.datas.bm_rate_header;
                    this.rows = response.data.datas.bm_rate_subdetail_storagecharge;
                    this.isLoading = false;
                    this.getRateBase();
                    this.getLocationCategory();
                })
                .catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
                    } else {
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push("/server-error");
                            } else {
                                this.$router.push("/page-not-found");
                            }
                        }
                    }
                });
        },

        logout() {
            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                console.log(response);
            });

            this.$logoutUser();
            window.location.href = "/";
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "RateHeaderCmlController") {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;

            this.loadItems();
        },
    },
    events: {},
    created: function () { },
    mounted() {
        this.fetchIt();
        this.loading();
    },
};
</script>
<style scoped>
.blur-content {
    filter: blur(5px);
}
</style>
